import Carousel from "./Carousel";

export default function Hero() {
  return (
    <div>
      <Carousel />
    </div>
  );
}
